/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Add_AromaInputs */

const en_add_aroma = /** @type {(inputs: Add_AromaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add Aroma`)
};

const es_add_aroma = /** @type {(inputs: Add_AromaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agregar aroma`)
};

/**
* | output |
* | --- |
* | "Add Aroma" |
*
* @param {Add_AromaInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const add_aroma = /** @type {((inputs?: Add_AromaInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Add_AromaInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_add_aroma(inputs)
	return es_add_aroma(inputs)
});